export default __webpack_public_path__ + "static/media/Group9176.a43ab018.svg";